// this is an autogenerated file from DesignSystem/PaymentAccount/PaymentAccountSelect/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_PaymentAccount_PaymentAccountSelect($patient_id: numeric!) {
  vaxiom_patients_by_pk(id: $patient_id) {
    id
    _id
    payment_accounts {
      payment_account {
        account_type
      }
      payor {
        _id
        id
        first_name
        greeting
        last_name
      }
      insurance_company {
        id
        carrier_name
      }
      insurance_plan {
        id
        number
      }
      insured_id
      payment_account_id
    }
  }
}

`